<template>
  <div
    class="metric-value"
    :class="{ 'has-data-table': hasDataTable }"
  >
    <div class="main-value">
      <slot
        name="value"
        :value="value"
      >
        <span class="value">{{ value }}</span>
      </slot>
      <slot name="comparison" />
    </div>
    <div
      v-if="subtitle || $slots['subtitle-suffix']"
      class="subtitle-row"
    >
      <span
        v-if="subtitle"
        class="subtitle"
      >{{ subtitle }}</span>
      <slot name="subtitle-suffix" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  value: {
    type: String,
    required: true
  },
  change: {
    type: [Number, String, null],
    default: null
  },
  previousValue: {
    type: String,
    default: null
  },
  subtitle: {
    type: String,
    default: ''
  },
  hasDataTable: {
    type: Boolean,
    default: false
  }
})

const changeType = computed(() => {
  if (props.change === null) return ''
  const numChange = typeof props.change === 'string' 
    ? parseFloat(props.change.replace('%', '')) 
    : props.change
  return numChange >= 0 ? 'positive' : 'negative'
})

const formatChange = (change) => {
  if (change === null) return ''
  if (typeof change === 'string' && change.includes('%')) {
    return change
  }
  return `${change}%`
}
</script>

<style scoped>
.metric-value {
  display: flex;
  flex-direction: column;
}

.main-value {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 4px;
}

.metric-value.has-data-table .main-value {
  margin-bottom: 4px;
}

.value {
  font-size: 28px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.15;
}


.subtitle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2px;
  min-width: 0;
}

.metric-value.has-data-table .subtitle-row {
  margin-top: 2px;
  padding-bottom: var(--date-range-padding-scrollable-data-tables);
}

.subtitle {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.87);
}
</style>
